import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/apiClient";
import {
  getCatalogueApiV1AdminAccessConfigCatalogueGet,
  listAccessConfigApiV1AdminAccessConfigGet,
} from "@/api/generated/sdk.gen";
import type {
  AccessConfigCatalogueSchema,
  AccessConfigRowSchema,
} from "@/api/generated/types.gen";

import { CLIENT_KEYS } from "@constants/clientKeys";

/** The togglable capabilities + configurable user types for the admin matrix. */
export const useAccessConfigCatalogue = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: [CLIENT_KEYS.ACCESS_CONFIG, "catalogue"],
    queryFn: async (): Promise<AccessConfigCatalogueSchema> => {
      const response = await getCatalogueApiV1AdminAccessConfigCatalogueGet({
        client: apiClient,
      });
      if ("error" in response && response.error) {
        throw new Error("Failed to load access-config catalogue.");
      }
      if (!response.data) throw new Error("Catalogue not found.");
      return response.data;
    },
    enabled,
    staleTime: 30 * 60 * 1000,
  });
};

/** Effective access config per configurable user type. */
export const useAccessConfig = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: [CLIENT_KEYS.ACCESS_CONFIG, "rows"],
    queryFn: async (): Promise<AccessConfigRowSchema[]> => {
      const response = await listAccessConfigApiV1AdminAccessConfigGet({
        client: apiClient,
      });
      if ("error" in response && response.error) {
        throw new Error("Failed to load access config.");
      }
      return response.data ?? [];
    },
    enabled,
    staleTime: 30 * 1000,
  });
};
